export function babble() {
  const containerInner = document.querySelector('.c-object__babble');
  if (containerInner) {
    setInterval(createBabble, 300);
  }

  function createBabble() {
    const babbleEl = document.createElement('span');
    const minSize = 20;
    const maxSize = 50;
    const size = Math.random() * (maxSize - minSize) + minSize;
    babbleEl.className = 'babble_0' + Math.trunc(Math.random() * 4);
    babbleEl.style.width = `${size}px`;
    babbleEl.style.height = `${size}px`;
    babbleEl.style.left = Math.random() * 100 + '%';
    babbleEl.style.opacity = Math.random() * 50 + '%';
    containerInner.appendChild(babbleEl);
    setTimeout(() => {
      babbleEl.remove();
    }, 15000);
  }
}
